<template>
  <div>
    <a
      role="link"
      tabindex="0"
      :aria-label="ratingLinkAccessibleLabel"
      class="rfp-rr-star-rating-product-173-or rfp-rr-star-rating-product__link"
      @click.prevent="callToActionRatingsTab"
      @keyup.enter="callToActionRatingsTab"
      @keyup.space="callToActionRatingsTab"
      @keydown.space.prevent
    >
      <refapp-star-rating
        aria-hidden="true"
        class="vue-star-rating rfp-rr-star-rating-product__link-star-rating"
        star-classes="vue-star-rating-star"
        :increment="starRatingIncrementValue"
        :max-rating="starRatingMaxRatingValue"
        :inactive-color="starRatingInactiveColor"
        :active-color="starRatingActiveColor"
        :star-size="starRatingStarSize"
        :rating="overallRating"
        readonly
      />
      <span class="rfp-avg-rating-or">
        {{ showWriteReviewButton ? '(0)' : starRatingText }}
      </span>
    </a>
    <button
      v-if="showWriteReviewButton"
      aria-haspopup="dialog"
      class="rfp-rr-star-rating-product__write-review-button"
      @click="writeReviewButtonClickHandler"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { handleWriteReviewButtonClick } from '../../../lib/widget/handleWriteReviewButtonClick';
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-star-rating-product',
  components: {
    RefappStarRating,
  },
  props: {
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    counts: {
      type: Number,
      required: false,
    },
    starRatingText: {
      type: String,
      required: false,
    },
    isZeroReviewModeEnabled: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    productItemId: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    ratingLinkAccessibleLabel: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      overallRating: this.rating,
    };
  },
  computed: {
    showWriteReviewButton() {
      return this.enabled && this.isZeroReviewModeEnabled && this.counts === 0;
    },
  },
  created() {
    this.autoFocusRatingsTab();
    eventBus.on('overallRatingTransferToComponent', () => {
      this.transferOverallRatings();
    });
  },
  methods: {
    callToActionRatingsTab() {
      setTimeout(() => {
        this.$scrollTo('#refapp-tabs-titles');
        document.querySelector('#refapp-tabs-titles')?.focus({ preventScroll: true });
      });
      eventBus.emit('focus-ratings-tab');
    },
    autoFocusRatingsTab() {
      /* istanbul ignore next */
      if (window.location.hash === '#ratings') {
        /* istanbul ignore next */
        setTimeout(function () {
          eventBus.emit('focus-ratings-tab');
          window.location.hash = '#ratings';
          this.$scrollTo('#ratings');
          document.querySelector('#ratings')?.focus({ preventScroll: true });
        }, 1000);
      }
    },
    transferOverallRatings() {
      eventBus.emit('overallRatingTransfer', this.overallRating);
    },
    writeReviewButtonClickHandler() {
      handleWriteReviewButtonClick({
        $cookies: this.$cookies,
        buttonText: this.buttonText,
        productItemId: this.productItemId,
      });
    },
  },
};
</script>
